const DEFAULT_BACKEND_PORT = '8000';

const isDirectDevServerAccess = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.location.port === '3000';
};

export const getApiBaseUrl = () => {
  const configuredApiBaseUrl = process.env.REACT_APP_API_URL;

  if (!configuredApiBaseUrl) {
    return `http://localhost:${DEFAULT_BACKEND_PORT}`;
  }

  if (configuredApiBaseUrl !== '/api') {
    return configuredApiBaseUrl;
  }

  if (isDirectDevServerAccess()) {
    return `${window.location.protocol}//${window.location.hostname}:${DEFAULT_BACKEND_PORT}`;
  }

  return configuredApiBaseUrl;
};
